<template>
    <div dir="rtl" class="mr-8 px-4 sm:px-6 lg:px-8">
        <div class="sm:flex sm:items-center">
            <div class="sm:flex-auto">
                <h1 class="text-xl font-semibold text-gray-900">جلسات الدارسين</h1>
                <p class="mt-2 text-sm text-gray-700"></p>
            </div>
        </div>

        <div class="mt-2 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            <select @change="changeSessionsId(masterSessionValue)" id="country" name="country"
                autocomplete="country-name"
                class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm pr-7"
                v-model="masterSessionValue">
                <option disabled value="" selected>الرجاء اختيار الجلسة</option>
                <option v-for="master in masterSessionsList" :key="master.id" :value="master.id">
                    {{ master.sessionsName }}</option>
            </select>
            
            <!-- Calendar Type Selection -->
            <select v-model="calendarType" 
                class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm pr-7">
                <option value="gregorian">التقويم الميلادي</option>
                <option value="hijri">التقويم الهجري</option>
            </select>
            
            <!-- Hijri/Gregorian Date Picker -->
            <div dir="ltr" class="w-full">
                <DatePicker
                    :initialType="calendarType"
                    v-model="selectedDate"
                    :language="'ar'"
                    format="dd-mm-yyyy"
                    :darkTheme="false"
                    placeholder="اختر التاريخ"
                    @update:modelValue="onDateChange"
                />
            </div>
            
            <div> <button class="button" type="submit" @click="getAllSessions()">بحث</button></div>
        </div>


        <div class="mt-8 flex flex-col">
            <div class="sm:flex-auto">
                <h1 class="text-lg font-medium text-gray-900"> الجلسات</h1>
                <p class="mt-2 text-xs text-gray-700"></p>
            </div>
            <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                    <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                        <table class="min-w-full divide-y divide-customHafadhColor">
                            <thead class="bg-customHafadhColor text-center">
                                <tr>
                                    <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                                        الاسم
                                    </th>
                                    <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                                        الايميل
                                    </th>
                                    <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                                        حالة الحضور للجلسة
                                    </th>
                                    <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                                        تاريخ الجلسة
                                    </th>
                                    <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                                        التسجيل الصوتي
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 bg-white">
                                <tr v-for=" (student, index) in students" :key="index">
                                    <td
                                        class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                                        {{ student.fullName }}
                                    </td>
                                    <td
                                        class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                                        {{ student.email }}
                                    </td>
                                    <td
                                        class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                                        {{ student.hasAttendedSessionToday == true ? "حاضر" : "غائب" }}
                                    </td>
                                    <td
                                        class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                                        {{ dateOfSearch }}
                                    </td>
                                    <td
                                        class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                                        <button class="enabled-button" @click="openPopup(index, student.id)">
                                            التسجيل</button>
                                        <!-- :class="{ 'cursor-not-allowed': !student.hasAttendedSessionToday }" -->
                                        <!-- :disabled="!student.hasAttendedSessionToday" -->
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <!-- Password Popup -->
        <div v-if="showPopup" class="popup" dir="rtl">
            <div class="popup-content">
                <h3 class="text-lg leading-6 font-medium text-gray-900">الاستماع للتسجيل</h3>
                <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">

                    <AudioPlayer :src="this.audioSrc" crossorigin="anonymous" />

                    <button
                        class="close mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                        @click="closePopup" type="button">اغلاق</button>

                </div>
            </div>
        </div>

        <!-- Error/Warning Modal -->
        <transition name="modal-fade">
            <div v-if="showErrorModal" class="fixed inset-0 z-50 overflow-y-auto" dir="rtl" @click.self="closeErrorModal">
                <div class="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
                    <!-- Background overlay -->
                    <div class="fixed inset-0 transition-opacity bg-gray-900 bg-opacity-50 backdrop-blur-sm"></div>

                    <!-- Modal panel -->
                    <div class="inline-block align-bottom bg-white rounded-2xl text-right overflow-hidden shadow-2xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                        <!-- Header with gradient -->
                        <div class="bg-gradient-to-r from-yellow-50 to-orange-50 px-6 py-4 border-b border-yellow-200">
                            <div class="flex items-center">
                                <div class="flex-shrink-0 flex items-center justify-center h-14 w-14 rounded-full bg-yellow-100 shadow-md">
                                    <svg class="h-8 w-8 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                    </svg>
                                </div>
                                <div class="mr-4 flex-1">
                                    <h3 class="text-xl font-bold text-gray-900" id="modal-title">
                                        تنبيه
                                    </h3>
                                    <p class="text-sm text-gray-600 mt-1">يرجى مراجعة المعلومات التالية</p>
                                </div>
                                <button
                                    @click="closeErrorModal"
                                    class="text-gray-400 hover:text-gray-600 transition-colors duration-200">
                                    <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        </div>

                        <!-- Content -->
                        <div class="bg-white px-6 py-5">
                            <div class="mt-2">
                                <p class="text-base text-gray-700 whitespace-pre-line leading-relaxed">
                                    {{ errorMessage }}
                                </p>
                                <div v-if="errorData && (errorData.studentName || errorData.date)" class="mt-5 p-4 bg-gradient-to-r from-gray-50 to-gray-100 rounded-xl border border-gray-200">
                                    <div class="space-y-2">
                                        <div v-if="errorData.studentName" class="flex items-center">
                                            <svg class="h-5 w-5 text-gray-500 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                            </svg>
                                            <span class="text-sm text-gray-600">الطالب:</span>
                                            <strong class="text-sm text-gray-900 mr-2">{{ errorData.studentName }}</strong>
                                        </div>
                                        <div v-if="errorData.date" class="flex items-center">
                                            <svg class="h-5 w-5 text-gray-500 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                            </svg>
                                            <span class="text-sm text-gray-600">التاريخ:</span>
                                            <strong class="text-sm text-gray-900 mr-2">{{ errorData.date }}</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Footer -->
                        <div class="bg-gray-50 px-6 py-4 sm:flex sm:flex-row-reverse border-t border-gray-200">
                            <button
                                type="button"
                                @click="closeErrorModal"
                                class="w-full inline-flex justify-center items-center rounded-xl border border-transparent shadow-lg px-6 py-3 bg-gradient-to-r from-customHafadhColor to-customHafadhColor/90 text-base font-semibold text-white hover:from-customHafadhColor/90 hover:to-customHafadhColor transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-customHafadhColor sm:mr-3 sm:w-auto sm:text-sm transform hover:scale-105">
                                <svg class="h-5 w-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                                </svg>
                                موافق
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import url from '@/url';
import axios from 'axios';
import { defineComponent } from 'vue';
import DatePicker from 'vue3-hijri-gregorian-datepicker';
import 'vue3-hijri-gregorian-datepicker/dist/style.css';
import AudioPlayer from './AudioPlayer.vue';


class masterSessionsDto {
    constructor(data) {
        this.id = data.id || null;
        this.sessionsId = data.sessionsId || null;
        this.sessionsName = data.sessionsName || null;
    }
}

class StudentDto {
    constructor(data) {
        this.id = data.id || null;
        this.email = data.email || null;
        this.fullName = data.fullName || null;
        this.engagementPreference = data.engagementPreference || null;
        this.qualificationValue = data.qualificationValue || null;
        // this.nationalId = data.nationalId || null; // Removed as it's not essential for app functionality
        this.canWithdraw = data.canWithdraw || false;
        this.isEnabled = data.isEnabled || false;
        this.phone = data.phone || false;
        this.massaratValue = data.massaratValue || null;
        this.hasAttendedSessionToday = data.hasAttendedSessionToday || null;
    }
}
export default defineComponent({
    components: {
        DatePicker,
        AudioPlayer
    },
    data() {
        return {
            students: [],
            showPopup: false,
            userIndex: '',
            sessionsId: "",
            masterSessionValue: "",
            masterSessionsList: [],
            dateOfSearch: "",
            selectedDate: {
                date: new Date(),
                type: 'gregorian'
            },
            calendarType: "gregorian",
            audioSrc: "",
            fullName: "",
            showErrorModal: false,
            errorMessage: "",
            errorData: null,
        }
    },
    mounted() {
        this.dateOfSearch = this.formattedDate(new Date());
        this.getMasterSessions();
    },
    methods: {
        async getAllSessions() {
            try {
                const response = await axios.get(process.env.VUE_APP_SERVICE_URL + url.get_students_sessions + this.masterSessionValue + "/" + this.dateOfSearch,
                    {
                        headers: {
                            'X-Authorization': localStorage.getItem('token'),
                        },
                    },
                );
                console.log(response);
                console.log(response.data.result.data);
                this.students = response.data.result.data.map(studentData => new StudentDto(studentData));
                console.log(this.students);
            } catch (error) {
                console.error(error);
            }
        },
        openPopup(index, studentId) {
            this.getStudentsDownload(studentId);
            this.userIndex = index;
        },
        closePopup() {
            this.showPopup = false;
            this.password = '';
            this.confirmPassword = '';
        },
        changeSessionsId(masterSessionValue) {
            this.sessionsId = this.masterSessionsList[masterSessionValue - 1].sessionsId;
            console.log(this.sessionsId);
        },
        getMasterSessions() {
            axios.get(process.env.VUE_APP_SERVICE_URL + url.master_sessions, {
                headers: {
                    'X-Authorization': localStorage.getItem('token'),
                }
            },)
                .then(response => {
                    this.masterSessionsList = response.data.result.data.map(data => new masterSessionsDto(data));
                    this.masterSessionValue = this.masterSessionsList[0].id;
                    this.sessionsId = this.masterSessionsList[0].sessionsId;
                    this.getAllSessions();
                })
                .catch(error => {
                    console.error('Error fetching data', error);
                });
        },
        onDateChange() {
            console.log('onDateChange called with:', this.selectedDate);
            if (this.selectedDate && this.selectedDate.date) {
                // Ensure we have a Date object
                const dateObj = this.selectedDate.date instanceof Date 
                    ? this.selectedDate.date 
                    : new Date(this.selectedDate.date);
                console.log('Processed date:', dateObj);
                this.dateOfSearch = this.formattedDate(dateObj);
            }
        },
        formattedDate(date) {
            if (date != null && date != undefined && date != "") {
                // Ensure we have a Date object
                const dateObj = date instanceof Date ? date : new Date(date);
                if (isNaN(dateObj.getTime())) {
                    console.warn('Invalid date:', date);
                    return '';
                }
                const year = dateObj.getFullYear();
                const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
                const day = dateObj.getDate().toString().padStart(2, '0');
                return `${year}-${month}-${day}`;
            }
            return '';
        },
        async getStudentsDownload(studentId) {
            try {
                // Use backend streaming endpoint to avoid CORS on presigned URL
                const streamUrl = `${process.env.VUE_APP_SERVICE_URL}/api/v1/admin/stream-recording/${studentId}/date/${this.dateOfSearch}`;

                const response = await axios.get(streamUrl, {
                    headers: {
                        'X-Authorization': localStorage.getItem('token'),
                    },
                    responseType: 'blob',
                    timeout: 15000,
                });

                // Create blob URL for audio player
                if (this.audioSrc && this.audioSrc.startsWith('blob:')) {
                    URL.revokeObjectURL(this.audioSrc);
                }
                this.audioSrc = URL.createObjectURL(response.data);
                this.showPopup = true;
            } catch (error) {
                console.error('Error fetching/streaming recording:', error);
                
                let errorMessage = 'حدث خطأ في جلب التسجيل';
                let errorData = null;
                
                if (error.response && error.response.data) {
                    const responseData = error.response.data;
                    if (responseData.result) {
                        errorMessage = responseData.result.mesAr || responseData.result.mesEn || errorMessage;
                        errorData = responseData.result.data || null;
                    } else if (responseData.messageAr) {
                        errorMessage = responseData.messageAr;
                    } else if (responseData.message) {
                        errorMessage = responseData.message;
                    }
                } else if (error.message) {
                    errorMessage = error.message;
                }
                
                this.showError(errorMessage, errorData);
            }
        },
        showError(message, data = null) {
            this.errorMessage = message;
            this.errorData = data;
            this.showErrorModal = true;
        },
        closeErrorModal() {
            this.showErrorModal = false;
            this.errorMessage = "";
            this.errorData = null;
        }
    }
})
</script>

<style scoped>
/* Tailwind utility classes for enabled and disabled button states */
.enabled-button {
    @apply px-4 py-2 bg-customHafadhColor text-white rounded hover:bg-customHafadhColor w-20 h-10;
}

.disabled-button {
    @apply px-4 py-2 bg-gray-300 text-gray-500 rounded cursor-not-allowed w-20 h-10;
}

.button-background {
    background: #679884;
}

.popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.popup-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 5px;
    width: 580px;
    height: 380px;
    text-align: center;
}

.button {
    @apply px-4 py-2 bg-customHafadhColor text-white rounded hover:bg-customHafadhColor w-20 h-10;
}

.close {
    margin-top: 50%;
    margin-right: 50%;
}

/* Modal transitions */
.modal-fade-enter-active, .modal-fade-leave-active {
    transition: opacity 0.3s ease;
}

.modal-fade-enter-from, .modal-fade-leave-to {
    opacity: 0;
}

.modal-fade-enter-active .inline-block,
.modal-fade-leave-active .inline-block {
    transition: transform 0.3s ease;
}

.modal-fade-enter-from .inline-block,
.modal-fade-leave-to .inline-block {
    transform: scale(0.95) translateY(-20px);
}
</style>